import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const getCreditCardsTE = <E = CF.API.ApiError>(
  { userId }: { userId: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.ListCreditCardsResponse> =>
  fetchTE<CF.API.Users.ListCreditCardsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/credit_cards`,
      method: 'GET',
    },
    onRejected,
  );

export type CreditCardPayload = {
  number: string;
  exp_month: string;
  exp_year: string;
  cvc: string;
  name: string;
  address_line_1: string;
  address_line_2: string;
  address_zip: string;
  address_country: string;
  address_city: string;
  address_state: string;
  default?: boolean;
};

export const addCreditCardTE = <E = CF.API.ApiError>(
  { userId, card }: { userId: string; card: CreditCardPayload },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.AddCreditCardsResponse> =>
  fetchTE<CF.API.Users.AddCreditCardsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/credit_cards`,
      method: 'POST',
      body: { card },
    },
    onRejected,
  );

export type EditCreditCardPayload = {
  id: string;
  name: string;
  default?: boolean;
  // Optional address fields -> This will be removed from edit payload after new stripe form integration
  address_line_1?: string;
  address_line_2?: string;
  address_zip?: string;
  address_country?: string;
  address_city?: string;
  address_state?: string;
};
export const editCreditCardTE = <E = CF.API.ApiError>(
  { userId, card }: { userId: string; card: EditCreditCardPayload },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.AddCreditCardsResponse> =>
  fetchTE<CF.API.Users.AddCreditCardsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/credit_cards`,
      method: 'PATCH',
      body: { cards: [{ ...card }] },
    },
    onRejected,
  );

export type DeleteCreditCardPayload = {
  id: string;
};
export const deleteCreditCardTE = <E = CF.API.ApiError>(
  { userId, card }: { userId: string; card: DeleteCreditCardPayload },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Users.DeleteCreditCardsResponse> =>
  fetchTE<CF.API.Users.DeleteCreditCardsResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/credit_cards`,
      method: 'DELETE',
      body: { card },
    },
    onRejected,
  );
